export default __webpack_public_path__ + "static/media/palm_tree.f95f75a7.png";